import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AuthService } from '../../../shared/services/auth/auth.service';
import { GtmService } from '../../../shared/services/gtm/gtm.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  standalone: false,
})
export class DashboardComponent implements OnInit, OnDestroy {
  public status: number = 0;
  public isRejected = false;
  private subscription = new Subscription();

  constructor(
    private authService: AuthService,
    private gtm: GtmService,
  ) {}

  ngOnInit() {
    this.getStatus();
    this.getIsRejected();
    this.gtm.sendVarGTM({ pageType: 'dashboard' });
  }

  private getStatus() {
    this.authService.updateStatus(true);
    this.authService.getStatus().subscribe((response) => {
      this.status = parseFloat(response);
    });
  }

  private getIsRejected() {
    this.subscription.add(
      this.authService
        .getRejectedMortgage()
        .subscribe((data) => (this.isRejected = data)),
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
